import { Component, Host, h, Element, Prop, Event, Listen, Watch, EventEmitter } from '@stencil/core';

@Component({
  tag: 'me-accordion',
  styleUrl: 'me-accordion.scss',
  shadow: false,
})
export class MeAccordion {
  @Element() host: HTMLMeAccordionElement;

  @Prop() theme: string = "content";

  @Watch('theme')
  onThemeChange() {
    this.meAccordionThemeChange.emit(this.host);
  }

  @Prop() alwaysOpen = false;

  @Event() meAccordionThemeChange: EventEmitter<HTMLMeAccordionElement>;

  @Listen('meAccordionItemToggle')
  toggleAccordionHandler(event: CustomEvent<HTMLMeAccordionItemElement>) {
    if (this.alwaysOpen) { return; }

    Array.from(event.detail.parentNode.children)
      .filter(isHTMLMeAccordionItemElement)
      .filter(accordionItem => accordionItem !== event.detail)
      .forEach(accordionItem => accordionItem.collapse());
  }

  private mutationObserver = new MutationObserver(this.updateVisibility.bind(this));

  connectedCallback() {
    this.mutationObserver.observe(this.host, { attributes: false, subtree: false, childList: true });
  }

  componentDidLoad() {
    this.onThemeChange();
  }

  disconnectedCallback() {
    this.mutationObserver.disconnect();
  }

  render() {
    return (
      <Host class={ "me-accordion me-accordion--" + this.theme }>
        <slot />
      </Host>
    );
  }

  private updateVisibility() {
    this.host.children.length === 0
      ? this.host.style.display = 'none'
      : this.host.style.display = null;
  }
}

function isHTMLMeAccordionItemElement(el: HTMLElement): el is HTMLMeAccordionItemElement {
  return el.tagName.toLowerCase() === 'me-accordion-item';
}
